<!--
   Created by qing on 2020/12/21
   Des: 新建/编辑 备注、附件、图片附件
-->
<template>

  <van-popup
    class="node-add-attach-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    get-container="body"
    :style="{ height: '100%', width: '100%' }"
    @close="beforeClose"
    position="right">
    <div class="node-add-container">

      <div class="content" v-if="itemInfo" :key="itemInfo.itemId">
        <div class="base-info">
          <van-field
            v-if="[MIX_FORM_ITEM_TYPE_IMAGE, MIX_FORM_ITEM_TYPE_ATTACHMENT].includes(itemInfo.itemType)"
            v-model="itemInfo.itemDetail.name"
            name="标题"
            label="标题"
            :required="true"
            :rules="[{ required: true, message: '请填写标题' }]"
          />

          <van-cell class="ry-form__rtf" >
            <template slot="title">
              <span class="title" style="color: #646566;">备注</span>

            </template>
            <template slot="label">
              <ry-quill-editor
                placeholder="请输入内容"
                :content.sync="itemInfo.itemDetail.remark">
              </ry-quill-editor>
            </template>
          </van-cell>

          <van-field
            label="上传附件"
            v-if="[MIX_FORM_ITEM_TYPE_ATTACHMENT, MIX_FORM_ITEM_TYPE_MEMO].includes(itemInfo.itemType)">
            <template #input>
              <div style="display: flex; flex-direction: column; width: 100%;">

                <el-button
                  style="width: 90px; padding: 5px 0"
                  type="text"
                  icon="el-icon-paperclip"
                  @click.stop.prevent.left="selectFile"
                >上传附件</el-button>

                <ul class="file__list" v-if="itemInfo.itemDetail.fileList.length">
                  <li v-for="(file, idx) in itemInfo.itemDetail.fileList">
                    <div class="file__icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                      </svg>
                    </div>
                    <div class="file__info">
                      <div class="file__info-name">
                        {{file.fileName}}
                      </div>
                      <div class="file__info-bottom">

                        <div class="file__info-size">
                          {{file.fileSize}}KB
                        </div>
                        <div class="file__info-handle">
                          <div
                            class="handle-button"
                            @click.stop.prevent.left="previewFile(file)">
                            预览
                          </div>
                          <div class="divider"></div>
                          <div
                            style="color: red"
                            class="handle-button"
                            @click.stop.prevent.left="itemInfo.itemDetail.fileList.splice(idx, 1)">
                            删除
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <file-preview-popup
                    ref="filePreviewPopup"
                    :stackList="stackList"
                  ></file-preview-popup>
                </ul>
              </div>
            </template>
          </van-field>

          <van-field
            label="上传图片"
            v-if="itemInfo.itemType === MIX_FORM_ITEM_TYPE_IMAGE">
            <template #input>
              <div style="display: flex; flex-direction: column;">

                <ul class="image__list">
                  <li
                    v-for="(img, idx) in itemInfo.itemDetail.fileList"
                    class="image__list-item"
                    :key="img.id">
                    <template>
                      <van-image
                        v-if="img.fileUrl"
                        width="60"
                        height="60"
                        @click="previewImage(idx)"
                        :src="img.fileUrl"
                        radius="6"
                        fit="cover">
                        <template v-slot:loading>
                          <van-loading
                            type="spinner"
                            size="20">
                          </van-loading>
                        </template>
                      </van-image>
                      <div v-else-if="img.status === 'uploading'" class="wait-upload-container">
                        <van-loading
                          type="spinner"
                          size="20">
                        </van-loading>
                      </div>
                      <van-image
                        v-else-if="img.status === 'fail'"
                        width="60"
                        height="60"
                        src=""
                        radius="6">
                        <template v-slot:error>上传失败</template>
                      </van-image>
                    </template>
                    <div
                      v-if="img.fileUrl || img.status === 'fail'"
                      @click="itemInfo.itemDetail.fileList.splice(idx, 1)"
                      class="image__list-remove">
                      <van-icon
                        size="14"
                        name="cross">
                      </van-icon>
                    </div>
                  </li>
                  <li
                    @click="selectImageFile"
                    class="image__list-add">
                    <van-icon
                      v-show="!showLoading"
                      size="30"
                      name="plus">
                    </van-icon>
                    <van-loading
                      v-show="showLoading"
                      type="spinner"
                      size="20">
                    </van-loading>
                  </li>
                </ul>
              </div>
            </template>
          </van-field>
        </div>


      </div>

      <div class="footer">
        <van-button
          @click="cancel">
          取 消
        </van-button>
        <van-button
          type="primary"
          @click="submitData">
          确定
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
  import {
    MIX_FORM_ITEM_TYPE_APPLY,
    MIX_FORM_ITEM_TYPE_ATTACHMENT, MIX_FORM_ITEM_TYPE_DASHBOARD, MIX_FORM_ITEM_TYPE_DATA,
    MIX_FORM_ITEM_TYPE_IMAGE,
    MIX_FORM_ITEM_TYPE_MEMO, MIX_FORM_ITEM_TYPE_MIX_FORM,
    MIX_FORM_ITEM_TYPE_NODE, MIX_FORM_ITEM_TYPE_VIEW
  } from "../../store/types";
  import {base64ToFile, clone, fileType2FileImage, getSimpleText, showSize} from "../../../assets/js/Untis";
  import {uuid} from "../../RyForm/utils";
  import {ImagePreview} from 'vant'
  import FilePreviewPopup from "./FilePreviewPopup";
  import {MESSAGE_TYPE_UPDATE_MIX_FORM_IMAGE} from "../../RyForm/types";

  export default {
    props: {
      mixFormId: {
        type: String,
        default: ''
      },
      stackList: {
        type: Array,
        default: () => []
      }
    },
    components: {FilePreviewPopup},
    data() {
      return {
        MIX_FORM_ITEM_TYPE_IMAGE,
        MIX_FORM_ITEM_TYPE_ATTACHMENT,
        MIX_FORM_ITEM_TYPE_MEMO,
        visibleInfo: {
          nodeId: '',
          visible: false
        },
        itemInfo: null,
        fileInput: null,
        showLoading: false,
        title: '',

        connectTopic: '',
        localIds: [],
        timer: null,
      }
    },
    created() {
      this.downloadEle = document.createElement('a')
      this.downloadEle.setAttribute('target', '_blank')
    },
    computed: {
    },
    methods: {

      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },
      async open(info) {
        this.itemInfo = clone(info)

        if (!this.fileInput) {
          this.fileInput = document.createElement('input')
          this.fileInput.setAttribute('type', 'file')
          this.fileInput.onchange = this.fileChange
        }
        this.fileInput.setAttribute('accept', '')

        if (info.itemType === MIX_FORM_ITEM_TYPE_IMAGE) {
          this.fileInput.setAttribute('accept', '.jpg, .jpeg, .png, .JPG, .JPEG, .PNG, .apng, .GIF, .webp, .BMP')
          this.title = '新建图片附件'

          const mqttConfig = await this.$store.dispatch('actionMixFormUploadImageMqttConfigGet', {
            mixFormId: this.mixFormId,
            nodeId: info.nodeId,
          })
          this.connectTopic = mqttConfig.topic
          this.$Socket.url = mqttConfig.mqttUrl
          this.$Socket.username = mqttConfig.username
          this.$Socket.password = mqttConfig.password

          await this.$Socket.init().catch(console.error)

          this.$Socket.subscribe(this.connectTopic, mesBody => {
            console.log('mix_form_mesBody', mesBody)
            if (mesBody.messageType === MESSAGE_TYPE_UPDATE_MIX_FORM_IMAGE) {
              // mesBody
              if (mesBody.content && mesBody.content.imageUpload) {
                mesBody.content.imageUpload.forEach(item => {
                  const existItem = this.itemInfo.itemDetail.fileList.filter(img => img.id === item.id)[0]
                  if (existItem) {
                    existItem.fileName = item.imgName
                    existItem.fileSize = item.imgSize
                    existItem.fileUrl = item.imgUrl
                    existItem.status = 'success'
                  } else {
                    this.value.push(item)
                  }
                })
                console.log('fileList', this.itemInfo.itemDetail.fileList)
              }
            }
          })
          this.checkUploadStatus()

        } else if (info.itemType === MIX_FORM_ITEM_TYPE_ATTACHMENT) {
          this.title = '新建附件'
        } else if (info.itemType === MIX_FORM_ITEM_TYPE_MEMO) {
          this.title = '新建备忘'
        }

        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true
      },
      beforeClose() {
        this.$emit('close')
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
      },

      fileChange(e) {
        const file = e.target.files[0]
        const fileInfo = {
          fileName: file.name,
          fileSize: (file.size / 1000).toFixed(2),
          fileUrl: '',
          fileType: file.type || file.name.split('.').slice(-1)[0],
          id: uuid('FILE')
        }
        console.log('fileInfo', fileInfo)
        this.showLoading = true
        this.$RyFs.upload(e.target.files)
          .then(res => {
            fileInfo.fileUrl = res[0]
            this.itemInfo.itemDetail.fileList.push(fileInfo)
            if (this.itemInfo.itemDetail.fileList.length === 1 &&
              ([MIX_FORM_ITEM_TYPE_ATTACHMENT, MIX_FORM_ITEM_TYPE_IMAGE].includes(this.itemInfo.itemType) &&
                !this.itemInfo.itemDetail.name)) {
              this.itemInfo.itemDetail.name = fileInfo.fileName
            }
            this.showLoading = false
          })
          .catch(err => {
            this.$toast.fail('上传失败')
            console.error(err)
            this.showLoading = false
          })
          .finally(() => {
            this.fileInput.value = ''
          })
      },
      selectFile() {
        this.fileInput.click()
      },

      // 图片上传
      selectImageFile() {
        // 判读是否是在微信环境
        if (window.isWexin || window.isWxWork) {
          // 微信环境就走jssdk选照片
          this.localIds.splice(0, this.localIds.length)
          console.log('chooseImage--',this.$wx)
          let that = this
          this.$wx.chooseImage({
            count: 9, // 允许上传的图片个数
            sizeType: ['original', 'compressed'],
            sourceType: ['album', 'camera'],
            success: function (res) {
              // 将返回的localIds全局保存
              console.log('chooseImage-suc-',res)
              that.localIds = res.localIds
              if (window.isWexin) {
                that.changeImgToBase64(that.localIds.shift());
              } else if (window.isWxWork) {
                that.uploadImageToWx(that.localIds.shift());
              } else {
                that.$toast.fail('图片上传出错')
              }
            },
            fail: err => {
              console.log('chooseImage-err-',err)
              this.fileInput.click()
            }
          })
        } else {
          // 其他环境就走网页网页选照
          this.fileInput.click()
          console.log('selectFile')
        }
      },
      // 将图片转换为base64
      changeImgToBase64(localId) {
        let that = this;
        this.$wx.getLocalImgData({
          localId: localId,
          success: function (res) {
            let localData = res.localData;
            let imageBase64 = '';
            if (localData.indexOf('data:image') === 0) {
              //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
              imageBase64 = localData;
            } else {
              //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
              //此时一个正常的base64图片路径就完美生成赋值到img的src中了
              imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
            }

            const appImgFile = base64ToFile(imageBase64)
            const size = showSize(imageBase64)
            that.uploadImage(appImgFile, size);
            // 递归调用
            if (that.localIds.length > 0) {
              that.changeImgToBase64(that.localIds.shift());
            }
          }
        })
      },
      uploadImage(appImgFile, size) {

        const fileInfo = {
          fileName: uuid('IMAGE_'),
          fileSize: size, // KB
          fileUrl: '',
          fileType: 'png',
          id: uuid('IMAGE')
        }

        this.showLoading = true
        this.$RyFs.upload([appImgFile])
          .then(urlList => {
            fileInfo.fileUrl = urlList[0]
            this.itemInfo.itemDetail.fileList.push(fileInfo)
            if (this.itemInfo.itemDetail.fileList.length === 1 &&
              ([MIX_FORM_ITEM_TYPE_ATTACHMENT, MIX_FORM_ITEM_TYPE_IMAGE].includes(this.itemInfo.itemType) &&
                !this.itemInfo.itemDetail.name)) {
              this.itemInfo.itemDetail.name = fileInfo.fileName
            }
            this.showLoading = false
          })
          .catch(err => {
            console.error(err)
            this.showLoading = false
          })
      },

      // 安卓用localId传到微信服务器，因为获取不到本地图片的base64
      uploadImageToWx(localId) {
        let that = this;
        this.$wx.uploadImage({
          localId: localId,
          success: function (res) {
            console.log('uploadImageToWx--', res)
            that.uploadToServer(res.serverId);
            // 递归调用
            if (that.localIds.length > 0) {
              that.uploadImageToWx(that.localIds.shift());
            }
          }
        })
      },
      uploadToServer(serverId) {
        const fileInfo = {
          fileName: uuid('IMAGE_'),
          fileSize: 0, // KB
          fileUrl: '',
          fileType: 'png',
          id: serverId,
          status: 'uploading',
          uploadTime: new Date().getTime()
        }
        this.itemInfo.itemDetail.fileList.push(fileInfo)
        if (this.itemInfo.itemDetail.fileList.length === 1 &&
          ([MIX_FORM_ITEM_TYPE_ATTACHMENT, MIX_FORM_ITEM_TYPE_IMAGE].includes(this.itemInfo.itemType) &&
            !this.itemInfo.itemDetail.name)) {
          this.itemInfo.itemDetail.name = fileInfo.fileName
        }

        this.$store.dispatch('ImageUploadToServer', {
          topic: this.connectTopic,
          mediaIdList: [serverId]
        }).catch(console.error)
      },

      checkUploadStatus() {
        if (this.itemInfo.itemDetail.fileList) {
          this.itemInfo.itemDetail.fileList.forEach(item => {
            if (item.status === 'uploading' && item.uploadTime && new Date().getTime() - item.uploadTime > 20000) {
              item.status = 'fail'
              console.log('upload fail-', item.id)
            }
          })
        }
        this.timer =  setTimeout(() => {
          this.checkUploadStatus()
        }, 5000)
      },
      // 预览图片
      previewImage(idx) {
        // if (window.isLark) {
        //   console.log('urls', this.current.value.map(item => item.imgUrl))
        //   console.log('current', this.current.value.map(item => item.imgUrl)[idx])
        //   this.$tt.ready(() => {
        //
        //     const urls = this.current.value.map(item => item.imgUrl)
        //     this.$tt.biz.util.previewImage({
        //       urls,
        //       current: urls[idx]
        //     });
        //
        //   })
        //
        // } else {
        ImagePreview({
          images: this.itemInfo.itemDetail.fileList.map(item => item.fileUrl),
          startPosition: idx
        })
        // }
      },

      previewFile(file) {

        if (this.$refs.filePreviewPopup) {
          this.$refs.filePreviewPopup.open(file, 'MIX_FORM')
        }

      },

      cancel() {
        const visibleInfo = this.stackList.pop()
        visibleInfo.visible = false
      },
      submitData() {
        if ([MIX_FORM_ITEM_TYPE_ATTACHMENT, MIX_FORM_ITEM_TYPE_IMAGE].includes(this.itemInfo.itemType) &&
          !this.itemInfo.itemDetail.name) {
          this.$toast.fail('请填写标题')
          return
        }
        if (this.itemInfo.itemType === MIX_FORM_ITEM_TYPE_MEMO) {
          if (!this.itemInfo.itemDetail.remark) {
            this.$toast.fail('请填写备注')
            return
          } else {
            this.itemInfo.itemDetail.name = getSimpleText(this.itemInfo.itemDetail.remark)
          }
        }
        if ([MIX_FORM_ITEM_TYPE_ATTACHMENT, MIX_FORM_ITEM_TYPE_IMAGE].includes(this.itemInfo.itemType) &&
          !this.itemInfo.itemDetail.fileList.length) {
          this.$toast.fail('请上传附件')
          return
        }
        const loading = this.$toast.loading()
        if (this.itemInfo.itemId) {
          this.$store.dispatch('actionMixFormNodeItemUpdate', {
            mixFormId: this.mixFormId,
            ...this.itemInfo
          }).then(res => {

            this.$emit('updateItemComplete', this.itemInfo)
            this.$toast.success('更新成功')
            this.cancel()
          }).catch(console.error)
            .finally(() => {
              loading.clear()
            })
        } else {
          this.$store.dispatch('actionMixFormNodeItemAdd', {
            ...this.itemInfo
          }).then(res => {
            this.$set(this.itemInfo, 'itemId', res.itemId)
            this.$emit('createItemComplete', this.itemInfo)
            this.$toast.success('创建成功')
            this.cancel()
          }).catch(console.error)
            .finally(() => {
              loading.clear()
            })
        }
      }
    }
  }
</script>

<style lang="less">

  .node-add-attach-popup {

    .van-field__label {
      width: 60px;
    }

    .node-add-container {
      background-color: #F6F6F6;
      width: 100%;
      height: calc(100% - env(safe-area-inset-bottom));
      position: relative;
      overflow: hidden;

      .content {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 44px;
        overflow: auto;

        .base-info {
          margin-top: 10px;
        }

        .image__list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;

          > .image__list-item {
            width: 60px;
            height: 60px;
            margin-right: 8px;
            margin-bottom: 8px;
            border-radius: 6px;
            position: relative;

            .wait-upload-container {
              width: 60px;
              height: 60px;
              border-radius: 6px;
              border: 1px solid #ebedf0;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            > .image__list-remove {
              position: absolute;
              right: -6px;
              top: -6px;
              width: 18px;
              height: 18px;
              border-radius: 50%;
              text-align: center;
              background-color: #333333;
              border: 1px solid #FFFFFF;
              display: flex;
              align-items: center;
              justify-content: center;

              > .van-icon.van-icon-cross {
                color: #FFFFFF;
                line-height: 14px;
              }
            }

          }

          > .image__list-add {
            width: 58px;
            height: 58px;
            line-height: 58px;
            text-align: center;
            border: 1px dashed #ebedf0;
            border-radius: 6px;
            margin-bottom: 8px;

            > i {
              font-size: 40px;
              line-height: 58px;
            }
          }
        }
      }

      .footer {
        background-color: #fff;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 44px;
        display: flex;
        justify-content: space-around;
        align-items: center;

        .van-button {
          width: 50%;
          border-radius: 0;
        }
      }
    }
  }
</style>